<template>
  <div class="main">
    <div class="sidebar">
      <Sidebar></Sidebar>
    </div>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import Sidebar from "./AnnouncementSidebar.vue";

export default {
  components: {
    Sidebar: Sidebar,
  },
};
</script>
<style lang="scss" scoped>
</style>
